export default __webpack_public_path__ + "static/media/section3_5.68c39d1e.png";